import { Box, Button, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

import withActions from "areas/product/hoc/with-actions"
import SizeOptions from "areas/product/jewlr/wizard-options/size-options"
import {
  ButtonWrapper,
  StyledButton,
} from "components/HalfModal/hm-styled-components"
import Modal, { closeModal } from "components/modal"
import { jewlr_t } from "helpers/application"

import SizeChart from "./size-chart"

const ResizeText = styled(Typography).attrs({
  color: "neutral",
  fontSize: 12,
  fontWeight: 300,
  letterSpacing: "-0.02em",
  lineHeight: "20px",
  mb: { _: 4, tablet: 3 },
  mt: { _: 1, tablet: 0 },
})``

const InnerRingSizeHalfModal = ({
  addToCart,
  availableHolidayDelivery,
  choices,
  forcePanelIndex,
  productType,
  wizardData,
}) => {
  const title = `${productType === "RING" ? "Ring" : ""} Size`
  const [loading, setLoading] = useState(false)
  const [modalTitle, setModalTitle] = useState(`Choose Your ${title}`)
  const [contentIndex, setContentIndex] = useState(0)

  useEffect(() => {
    if (contentIndex == 1) {
      setModalTitle(`${title} Guide`)
    } else if (contentIndex == 2) {
      setModalTitle(`${productType === "RING" && "Ring"} Sizing Chart`)
    } else {
      setModalTitle(`Choose Your ${title}`)
    }
    return () => {}
  }, [contentIndex])

  if (!wizardData || !wizardData.sz) {
    return ""
  }

  const onNext = () => {
    setContentIndex(contentIndex + 1)
  }

  const onBack = () => {
    setContentIndex(contentIndex - 1)
  }

  // const goToSizeChart = (e) => {
  //   if (e.target.parentElement.hasAttribute("data-link-override")) {
  //     onNext(e)
  //     e.preventDefault()
  //   }
  // }

  const sizeTipText = wizardData.sz.not_a_ring ? (
    ""
  ) : (
    <Box textAlign="center">
      <Typography
        fontSize={16}
        fontWeight={500}
        letterSpacing="-0.02em"
        lineHeight="20px"
        mb={1}
      >
        The average ring size for {wizardData.sz.male ? "men" : "women"} is{" "}
        {wizardData.sz.avg_size}
      </Typography>
      <Typography
        color="neutral"
        fontSize={14}
        fontWeight={500}
        letterSpacing="-0.02em"
        lineHeight="20px"
        mb={{ _: 1, tablet: 0 }}
      >
        Unsure of the size? Please see our{" "}
        <Button
          color="primary"
          onClick={() => onNext()}
          underline
          variant="text"
        >
          Size Chart
        </Button>
      </Typography>
      {availableHolidayDelivery && (
        <Typography
          bold
          color="greenDarker"
          fontWeight={300}
          mb={{ _: 1, tablet: 0 }}
        >
          *Note: Sizes marked in green are available for{" "}
          {sl.config.guaranteed_holiday} Delivery.
        </Typography>
      )}
      {wizardData.sz.size_tip && (
        <ResizeText>{wizardData.sz.size_tip}</ResizeText>
      )}
    </Box>
  )

  return (
    <Modal
      contentIndex={contentIndex}
      contentStyle={
        contentIndex === 0
          ? {
              pb: { _: 4, tablet: "36px" },
              pt: 0,
            }
          : {}
      }
      headerStyle={{
        mb: { _: 3, tablet: "10px" },
      }}
      height={contentIndex === 0 ? "fit-content" : "full"}
      label={modalTitle}
      labelStyle={{
        textTransform: "capitalize",
      }}
      onBack={onBack}
      onClose={() => {
        forcePanelIndex("sz")
        closeModal()
        setTimeout(() => setContentIndex(0), 400)
      }}
      show="#ring-size"
      variant={contentIndex === 0 ? "squircle" : "slideup"}
      width="640px"
    >
      {contentIndex == 1 && <SizeChart />}
      {contentIndex == 0 && (
        <>
          <div>
            {sizeTipText}
            <SizeOptions
              modal
              opened
              pref={wizardData.sz.pref}
              sizePref={null}
            />
          </div>
          <ButtonWrapper>
            <StyledButton
              data-cy="product-modal-sz-proceed-to-cart-btn"
              disabled={choices && choices.sz && choices.sz.value === ""}
              loading={loading}
              onClick={(e) => {
                setLoading(true)
                addToCart(e)
              }}
              variant="primary"
            >
              Proceed to {jewlr_t("Cart")}{" "}
            </StyledButton>
          </ButtonWrapper>
        </>
      )}
    </Modal>
  )
}

InnerRingSizeHalfModal.propTypes = {
  addToCart: PropTypes.func,
  availableHolidayDelivery: PropTypes.bool,
  choices: PropTypes.object,
  forcePanelIndex: PropTypes.func,
  productType: PropTypes.string,
  wizardData: PropTypes.object,
}
const mapStateToProps = (state) => {
  return {
    availableHolidayDelivery:
      state.wizard.shipping.main &&
      state.wizard.shipping.main.available_holiday_delivery &&
      state.wizard.inventory &&
      !state.wizard.inventory.non_inventory_available_holiday_delivery,
    productType: state.wizard.description.product_type,
  }
}

const RingSizeHalfModal = connect(mapStateToProps)(
  withActions(InnerRingSizeHalfModal)
)

export default RingSizeHalfModal
